/* Установщик «Reels»: объект в window на том месте порядка скриптов, где стоял assets/bot-reels.js.
   В серверном режиме движок шаблона получает сервер экрана (reels-server.ts), а экран reels встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createReels } from './engine';
import { createReelsServer, registerReelsEngine } from './reels-server';

export function installReels() {
  const server = isServerMode();
  createReels(server ? createReelsServer : null);
  if (server) registerReelsEngine();
}
